module.exports = __webpack_public_path__ + "assets/img/wukuang.49457abf.png";